import React, { useState } from 'react'
import { func } from 'prop-types'
import onClickOutside from 'react-onclickoutside'
import Link from 'common/components/link'
import Button from 'common/components/button'
import Icon from 'common/components/icon'
import { ACCOUNT_LINK } from 'services/utility/constants'
import './index.scss'

const AccountMenu = ({
  signOut,
  setShowAccountMenu,
}) => {
  const [loading, setLoading] = useState(false)
  const signOutClickHandler = () => {
    setLoading(true)
    signOut().then(() => setLoading(false))
  }
  AccountMenu.handleClickOutside = () => setShowAccountMenu(false)
  return (
    <div className="account-menu">
      <div className="arrow-up" />
      <div className="account-menu__header">
        Your Account
      </div>
      <div className="account-menu__body">
        <ul className="account-menu__list">
          <li className="account-menu__list__item">
            <Link
              href={ACCOUNT_LINK}
              asAnchor
              className="profile-link"
              dataAutoId="btnAccountSettings"
            >
              <Icon name="settings" size="medium" />
              Account settings
            </Link>
          </li>
        </ul>
        <Button
          clickHandler={signOutClickHandler}
          className="asda-btn--fluid sign-out_btn"
          category="secondary"
          loading={loading}
        >
          Sign out
        </Button>
      </div>
    </div>
  )
}

AccountMenu.propTypes = {
  signOut: func.isRequired,
  setShowAccountMenu: func.isRequired,
}

const clickOutsideConfig = {
  handleClickOutside: () => AccountMenu.handleClickOutside,
}

const withOnClickOutside = onClickOutside(AccountMenu, clickOutsideConfig)

export {
  withOnClickOutside as default,
  AccountMenu,
}



// WEBPACK FOOTER //
// ./components/account-menu/index.js